import React from 'react';

import { cssMap } from '@atlaskit/css';
import Image from '@atlaskit/image';
import { Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import type { JSMCreateSurveyData } from '@atlassian/rovo-content-bridge-api-commands/commands/jsm-create-survey';

import PageHeaderImage from '../../../assets/preview-card-survey-header.svg';

const styles = cssMap({
	container: {
		paddingLeft: token('space.200'),
		paddingRight: token('space.200'),
		paddingTop: token('space.200'),
		paddingBottom: token('space.200'),
	},
});

export const JsmCreateSurveyPreviewContent = ({
	selectedFormQuestions: { title },
}: Omit<JSMCreateSurveyData, 'portalId'>): React.JSX.Element => (
	<Stack space="space.150" xcss={styles.container}>
		<Stack>
			<Image src={PageHeaderImage} alt="Survey preview card" />
		</Stack>
		<Text weight="medium" color="color.link">
			{title}
		</Text>
	</Stack>
);
